<footer class="bg-color-tertiary" *ngIf="!utilsService.feature?.includes('instruction')">

  <div class="container mar-t-5 color-white">
    <div class="row pad-y-3 pad-r-y-2">
      <div class="col-lg-10">
        <p class="mb-0 body-m body-r-s">
          <a [href]="'FOOTER.' + clientId + '.RANDSTADURLLEGAL' | translate" target="_blank">
            {{ 'FOOTER.' + clientId + '.TERMSCONDITIONS' | translate }}
          </a> |
          <a [href]="'FOOTER.' + clientId + '.RANDSTADURLPRIVACY' | translate" target="_blank">
            {{ 'FOOTER.' + clientId + '.PRIVACY' | translate }}
          </a>
        </p>
        <span class="body-s body-r-xs">{{ "© " + currentYear + ('FOOTER.' + clientId + '.RIGHTS' | translate) }}</span>
      </div>
      <div class="col-lg-2 col-6 mar-r-t-2">
        <img src="/assets/images/randstad-logo.svg">
      </div>
    </div>
  </div>
</footer>
